export default __webpack_public_path__ + "static/media/gravatar.51a273ec.svg";